// © Microsoft Corporation. All rights reserved.

export namespace DynamicBundles {
    const dynamicBundles: { [experienceName: string]: () => Promise<any> } = {};

    /**
     * lazy load the experience
     *
     * @param experienceName - the experience name
     * @return {Promise<any>} - the experience wrapped by the promise
     */
    export const loadExperience =  async (experienceName: string) => {
        const bundle = dynamicBundles[experienceName];
        if (!bundle) {
            throw new Error(`Attempted to load unknown dynamic bundle "${experienceName}". Make sure it's a registered dynamic experience bundle.`);
        }
        return bundle();
    }

    /**
     * register the experience for lazy loading
     *
     * @param experienceName - the experience name
     * @param es6Import - the import("@msnews/your/experience/path")
     */
    export const registerExperience = (experienceName: string, es6Import: () => Promise<any>) => {
        dynamicBundles[experienceName] = es6Import;
    };
}